import React, { useState, useEffect, useCallback, useRef } from "react";
import Index from "../../../../component/Index";
import ContainerIndex from "../../../Index";
import { styled } from "@mui/material/styles";
import { TextareaAutosize } from "@mui/base";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  Autocomplete,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { Controller } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import {
  getPurchaseVoucherPrerequisiteDataApiHandler,
  generateSalesVoucherEntryApiHandler,
  getSalesVoucherEntryListApiHandler,
} from "../../../../services/AdminIndex";
import LoadingSpinner from "../../../../component/LoadingSpinner";
import moment from "moment";

const Item = styled(Index.Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default function GeneratePurchaseVoucher() {
  const { id } = useParams();
  const navigate = useNavigate();
  const editId = id;

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    watch,
  } = Index.useForm();

  const dispatch = useDispatch();
  const inputRefs = useRef({});
  const [allVoucherNo, setAllVoucherNo] = useState([]);

  const [editData, setEditData] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const [taxCategoryOptions, setTaxCategoryOptions] = useState([]);

  const [sundryCreditors, setSundryCreditors] = useState();
  const [currencies, setCurrencies] = useState();
  const [brokers, setBrokers] = useState();
  const [hsn, setHsn] = useState();
  const [purchaseAccount, setPurchaseAccount] = useState();
  const [expenseAccount, setExpenseAccount] = useState([]);

  const [narrationDropdown, setNarrationDropdown] = useState(false);
  const [narrationList, setNarrationList] = useState([]);
  const [supplierDeductTDSStatus, setSupplierDeductTDSStatus] = useState(0);

  useEffect(() => {
    if (!editId) {
      const currencyId = currencies?.[0]?.id;
      setValue("currency", currencyId);
      setValue("rcm", 0);
    }
  }, [currencies]);

  // API call for Get sales account, sundry deboters, brokers
  const getPurchaseVoucherEntryPrerequisiteData = () => {
    dispatch({ type: "LOADER_START" });
    try {
      getPurchaseVoucherPrerequisiteDataApiHandler(token, editId, 0).then(
        (data) => {
          dispatch({ type: "LOADER_START" });
          if (data.status === 201 || data.status === 200) {
            setSundryCreditors(data?.data?.sundryCreditors);
            setCurrencies(data?.data?.currencies);
            setBrokers(data?.data?.broker);
            setPurchaseAccount(data?.data?.purchaseAccount);
            setTaxCategoryOptions(data?.data?.taxCategory);
            setNarrationList(data?.data?.narration);
            setExpenseAccount(data?.data?.expenceAccount);
            setHsn(data?.data?.hsn);
            let tempArray = [];
            data?.data?.voucherNos?.map((ele) => {
              tempArray.push(ele?.voucherNo);
            });
            setAllVoucherNo(tempArray);
            dispatch({ type: "LOADER_END" });
          } else {
            dispatch({ type: "ADMIN_ERROR_HANDLER", payload: data });
          }
        },
      );
    } catch (error) { }
  };
  useEffect(() => {
    getPurchaseVoucherEntryPrerequisiteData();
  }, []);

  useEffect(() => {
    setBrokerOfParty(watch("party"));
  }, [sundryCreditors]);

  // Set broker, credit days, discount, taxCategory, transport and sub broker on party selection  by party
  const setBrokerOfParty = (partyId) => {
    const filteredAccountmaster = sundryCreditors?.filter(
      (ele) => ele?.id == partyId,
    );
    if (!editId) {
      setValue("broker", filteredAccountmaster?.[0]?.brokerId || "");
      setValue("creditDays", filteredAccountmaster?.[0]?.creditDays || 0);
      // Only set jvTds in ADD mode, not edit mode
      setValue("jvTds", filteredAccountmaster?.[0]?.deductTDS == "Yes" ? 1 : 0);
    }

    setSupplierDeductTDSStatus(
      filteredAccountmaster?.[0]?.deductTDS == "Yes" ? 1 : 0,
    );
    setValue("tdsAccount", filteredAccountmaster?.[0]?.TDSAcc);
    setValue("tdsPercentage", filteredAccountmaster?.[0]?.tdsPercentage);
    setValue(
      "salesType",
      filteredAccountmaster?.[0]?.salesType != 0
        ? filteredAccountmaster?.[0]?.salesType
        : "",
    );
  };

  // useEffect(() => {
  //   if (!editId) {
  //     const voucherNo = generateInvoiceNumber();
  //     setValue("voucherNo", voucherNo);
  //   }
  // }, [allVoucherNo]);
  // Generate invoice number
  // function generateInvoiceNumber(str = "") {
  //   let invoiceNos = allVoucherNo;
  //   const matchingNumbers = invoiceNos?.find((item) =>
  //     item.startsWith(str.toUpperCase())
  //   );
  //   if (!matchingNumbers) {
  //     if (!invoiceNos?.length && str == "") {
  //       return "000000000001";
  //     } else {
  //       let originalString = str;
  //       let remainingLength = 12 - originalString.length;

  //       if (remainingLength >= 1) {
  //         originalString += "0".repeat(remainingLength - 1) + "1";
  //       }
  //       return originalString.toUpperCase();
  //     }
  //   } else {
  //     const incrementedNumbers = matchingNumbers.replace(
  //       /(\d+)$/,
  //       function (match) {
  //         // Increment the matched number
  //         return String(Number(match) + 1).padStart(match.length, "0");
  //       }
  //     );
  //     return incrementedNumbers.toUpperCase();
  //   }
  // }

  const [taxRow, setTaxRow] = useState([
    {
      id: Math.random(),
      taxId: "",
      taxType: "",
      taxCode: "",
      taxName: "",
      netAmount: "",
      taxRate: "",
      amount: "",
      balance: "",
      calculated: "",
      calculatedOn: "",
      roundOffType: "",
      salesLiablityAccount: "",
      salesLiablityId: "",
    },
  ]);
  const { loading, token, selectedYearStart, selectedYearEnd } =
    Index.useSelector((state) => {
      return state.ERPAdminReducer;
    });

  useEffect(() => {
    if (!editId) {
      // Set today date if selected year is current financial year or set start date of selected year
      const currentDate = dayjs();
      const fyStart = dayjs(selectedYearStart).startOf("day");
      const fyEnd = dayjs(selectedYearEnd).endOf("day");

      const fyStartDate = dayjs(`01-04-${fyStart.year()}`, "DD-MM-YYYY");
      const fyEndDate = dayjs(`31-03-${fyEnd.year()}`, "DD-MM-YYYY");

      let dateToShow = currentDate;

      // If currentDate is NOT within financial year, use start of financial year
      if (!currentDate.isBetween(fyStartDate, fyEndDate, null, "[]")) {
        dateToShow = fyEndDate;
      }
      setValue("voucherDate", dayjs(dateToShow));
    }
  }, [selectedYearStart]);

  useEffect(() => {
    if (!editId) {
      setValue("accountType", "purchase");
    }
  }, []);

  useEffect(() => {
    if (editId && !watch("rcm")) {
      addTaxRow();
    }
  }, [watch("rcm")]);

  const getEditData = () => {
    dispatch({ type: "LOADER_START" });
    getSalesVoucherEntryListApiHandler(token, editId, 0).then((data) => {
      dispatch({ type: "LOADER_START" });
      if (data.status === 201 || data.status === 200) {
        setEditData(data?.data?.[0]);
        dispatch({ type: "LOADER_END" });
      } else {
        dispatch({ type: "ADMIN_ERROR_HANDLER", payload: data });
      }
    });
  };

  // Call edit API
  useEffect(() => {
    if (editId) {
      getEditData();
    }
  }, []);

  useEffect(() => {
    if (editId) {
      setValue("jvTds", editData.jvTds ? 1 : 0);

      // Phir setBrokerOfParty call karo (jo ab jvTds override nahi karega)
      setBrokerOfParty(editData?.party);
      setValue("accountType", editData?.accountType);
      setValue("salesAccountId", editData?.salesAccountId);
      setValue("party", editData?.party);

      setValue("voucherNo", editData?.voucherNo);
      setValue("voucherDate", dayjs(editData?.voucherDate));
      setValue("broker", editData?.brokerId);
      setValue("currency", editData?.currencyId);
      setValue("creditDays", editData?.crDays);
      setValue("note", editData?.note);
      setValue("netAmount", editData?.netAmount);
      setNarrationList((prev) => [...prev, { narrat: editData?.narration }]);
      setValue("narration", editData?.narration);
      setValue("hsnId", editData?.hsnId);
      setValue("jvTds", editData.jvTds ? 1 : 0);
      setValue("rcm", editData.rcm ? 1 : 0);
      setValue("totalTaxAmount", editData?.taxAmount);
      setValue("totalAmount", editData?.totalAmount);

      let taxData = parseData(editData?.voucherEntryTaxData);
      // Rearrange sequence of tax row Like 1. C.GST, 2. S.GST, 3. I.GST then others

      const sortOrder = ["C.GST", "S.GST", "I.GST"];

      // taxData.sort((a, b) => {
      //   const indexA = sortOrder.indexOf(a.tax_type);
      //   const indexB = sortOrder.indexOf(b.tax_type);

      //   // If both items are in the sort order, compare by index in the sort order
      //   if (indexA !== -1 && indexB !== -1) {
      //     return indexA - indexB;
      //   }

      //   // If one item is in the sort order and the other isn't, prioritize the one in the sort order
      //   if (indexA !== -1) return -1;
      //   if (indexB !== -1) return 1;

      //   // If neither item is in the sort order, maintain their relative order
      //   return 0;
      // });
      setTaxRow(taxData);

      taxData?.map((row, index) => {
        const rowObject = {
          id: row?.id,
          taxId: row?.taxId,
          taxCode: row?.tax_code,
          taxName: row?.tax_name,
          netAmount: row?.netAmount,
          taxRate: row?.tax_rate,
          amount: row?.amount,
          balance: row?.balance,
          calculated: row?.calculated,
          calculatedOn: row?.calculated_on,
          roundOffType: row?.round_off_type,
          salesLiablityAccount: row?.salesLiablityAccount,
          salesLiablityId: row?.salesLiablityId,
        };

        setTaxRow((data) => {
          let arr = [...data];
          arr[index] = rowObject;
          return arr;
        });
      });
    }
    setBrokerOfParty(editData?.party);
  }, [editData]);
  const validateData = (arr) => {
    let error = {};
    //check if any row is empty
    if (!watch("rcm")) {
      arr?.map((row, mainIndex) => {
        if (!row?.taxId) {
          error["taxId" + mainIndex] = "Tax Name is require";
        }
      });
    }

    return error;
  };
  const checkIncludeError = (key) => {
    return Object.keys(validateData(taxRow)).includes(key) && submitted;
  };

  const submit = (data) => {
    setSubmitted(true);
    if (!Object.keys(validateData(taxRow))?.length) {
      data.type = "purchaseVoucher";
      data.voucherDate = ContainerIndex.convertDate(data?.voucherDate || "");
      data.rcm = data?.rcm ? 1 : 0;
      data.totalTaxAmount = data?.rcm
        ? 0
        : taxRow?.reduce(
          (sum, data) =>
            data?.taxType !== "OTHERS"
              ? sum + (Number(data?.amount) || 0)
              : sum,
          0,
        );
      data.totalAmount = data?.rcm ? data.netAmount : data.totalAmount;

      if (editId) {
        data.id = editId;
      }

      if (!watch("rcm")) {
        data.taxData = taxRow;
      } else {
        data.taxData = [];
      }

      //account data
      const partyAccountData = {
        entryType: "purchaseVoucher",
        accountId: data?.party,
        oppositeId: data?.salesAccountId,
        type: "CR",
        amount: Number(data?.totalAmount),
      };
      if (editId) {
        partyAccountData.salesReference = editId;
      }

      const salesAccountData = {
        entryType: "purchaseVoucher",
        accountId: data?.salesAccountId,
        oppositeId: data?.party,
        type: "DR",
        amount: Number(data?.netAmount),
      };
      if (editId) {
        salesAccountData.salesReference = editId;
      }
      let accountEntryData = [];
      accountEntryData.push(salesAccountData);
      accountEntryData.push(partyAccountData);
      if (!watch("rcm")) {
        taxRow?.map((tax) => {
          if (tax?.amount) {

            if (!tax?.salesLiablityId || tax?.salesLiablityId === 'undefined') {

              let crIndex = accountEntryData.findIndex(item => item.type === "DR");

              if (crIndex !== -1) {
                if (tax?.calculated === "ADD") {
                  accountEntryData[crIndex].amount += Number(tax?.amount);
                } else if (tax?.calculated === "DEDUCT") {
                  accountEntryData[crIndex].amount -= Number(tax?.amount);
                }
              }

            } else {

              let row = {
                entryType: "purchaseVoucher",
                accountId: Number(tax?.salesLiablityId),
                oppositeId: data?.party,
                type: tax?.calculated != "DEDUCT" ? "DR" : "CR",
                amount: Number(tax?.amount),
              };

              if (editId) {
                row.salesReference = editId;
              }

              accountEntryData.push(row);
            }
          }
        });
      }

      let JVAmount = 0;

      // JV tds calculation
      if (data.jvTds && data.tdsAccount && data.tdsPercentage) {
        JVAmount = ((data?.netAmount * data?.tdsPercentage) / 100).toFixed(2);
        //Credit JV to jv account
        let JVCredit = {
          entryType: "purchaseVoucher",
          bookType: "JV",
          accountId: Number(data?.tdsAccount),
          oppositeId: data?.party,
          type: "CR",
          amount: Number(JVAmount),
          narration1: `T.D.S. DEDUCTED AGAINST BILL NO. ${data?.voucherNo
            } DATED ${moment(data?.voucherDate).format("DD-MM-YYYY")}`,
        };

        //Debit JV to party
        let JVDebit = {
          entryType: "purchaseVoucher",
          bookType: "JV",
          accountId: Number(data?.party),
          oppositeId: data?.tdsAccount,
          type: "DR",
          amount: Number(JVAmount),
          narration1: `T.D.S. DEDUCTED AGAINST BILL NO. ${data?.voucherNo
            } DATED ${moment(data?.voucherDate).format("DD-MM-YYYY")}`,
        };

        accountEntryData.push(JVCredit);
        accountEntryData.push(JVDebit);
      }
      data.autoJVAmt = JVAmount;

      data.accountEntryData = accountEntryData;
      // return false;

      try {
        generateSalesVoucherEntryApiHandler(token, data).then((response) => {
          if (response.status === 201 || response.status === 200) {
            if (editId) {
              toast.success("Purchase entry updated successfully");
            } else {
              toast.success("Purchase entry created successfully");
            }
            dispatch({ type: "LOADER_END" });
            navigate("/dashboard/purchase-voucher-entry-list");
          } else {
            dispatch({ type: "ADMIN_ERROR_HANDLER", payload: response });
          }
        });
      } catch (e) { }
    }
  };

  const parseData = (data) => {
    try {
      // if plain js
      if (data) {
        let result = JSON.parse(data);
        return result;
      } else {
        return [];
      }
    } catch (e) {
      return [];
    }
  };

  // const addTaxRow = () => {
  //   setTaxRow((data) => [
  //     ...data,
  //     {
  //       id: Math.random(),
  //       taxId: "",
  //       taxType: "",
  //       taxCode: "",
  //       taxName: "",
  //       netAmount: "",
  //       taxRate: "",
  //       amount: "",
  //       balance: "",
  //       calculated: "",
  //       calculatedOn: "",
  //       roundOffType: "",
  //       salesLiablityAccount: "",
  //       salesLiablityId: "",
  //     },
  //   ]);
  // };
  // const removeTaxRow = (id) => {
  //   setTaxRow((data) => {
  //     let arr = [...data];
  //     return arr.filter((e) => e?.id !== id);
  //   });

  //   let netAmount = watch("netAmount");
  //   let displayNetAmount = watch("netAmount");
  //   let totalTaxAmount = 0;
  //   let balance = watch("netAmount");

  //   let previousTaxAmount = 0;
  //   const modifiedTaxRow = taxRow?.filter((e) => e?.id !== id);
  //   modifiedTaxRow?.map((row, index) => {
  //     if (row?.taxId) {
  //       const tax = taxCategoryOptions?.find((ele) => ele?.Id == row?.taxId);
  //       if (
  //         (watch("salesType") == "Local" && tax?.tax_type != "I.GST") ||
  //         (watch("salesType") != "Local" &&
  //           tax?.tax_type != "S.GST" &&
  //           tax?.tax_type != "C.GST")
  //       ) {
  //         let taxAmount = 0;
  //         if (tax?.tax_rate) {
  //           if (tax?.calculated_on == "ON GROSS AMOUNT") {
  //             taxAmount = ((displayNetAmount * tax?.tax_rate) / 100).toFixed(2);
  //           } else if (tax?.calculated_on == "BALANCE AMOUNT") {
  //             taxAmount = ((balance * tax?.tax_rate) / 100).toFixed(2);
  //           } else if (tax?.calculated_on == "REPEAT PRV.TAX AMT") {
  //             taxAmount = previousTaxAmount;
  //           } else {
  //             taxAmount = ((displayNetAmount * tax?.tax_rate) / 100).toFixed(2);
  //           }
  //         } else {
  //           taxAmount = Number(row?.amount);
  //         }

  //         // Set this tax amount in previous tax amount for next row if has repeat previous tax amount previous
  //         previousTaxAmount = taxAmount;

  //         // get amount on base of rounded type define in tax master
  //         taxAmount = getRoundedTaxAmount(tax?.round_off_type, taxAmount);
  //         balance = getBalanceAmount(
  //           tax?.calculated,
  //           Number(balance),
  //           Number(taxAmount || 0)
  //         );

  //         if (tax?.calculated != "DEDUCT") {
  //           totalTaxAmount += Number(taxAmount);
  //         }

  //         const obj = {
  //           id: Math.random(),
  //           taxId: row?.taxId,
  //           taxType: tax?.tax_type,
  //           taxCode: tax?.tax_code,
  //           taxName: tax?.tax_name,
  //           netAmount: Number(displayNetAmount).toFixed(2),
  //           taxRate: tax?.tax_rate,
  //           amount: taxAmount,
  //           balance: balance,
  //           calculated: tax?.calculated,
  //           calculatedOn: tax?.calculated_on,
  //           roundOffType: tax?.round_off_type,
  //           salesLiablityAccount: tax?.salesLiablityAccount,
  //           salesLiablityId: tax?.salesLiablityId,
  //         };
  //         setTaxRow((data) => {
  //           let arr = [...data];
  //           arr[index] = obj;
  //           return arr;
  //         });
  //         if (tax?.tax_type == "OTHERS") {
  //           displayNetAmount = Number(
  //             Number(displayNetAmount) + Number(taxAmount)
  //           );
  //         }
  //       }
  //     }
  //   });

  //   setValue("totalTaxAmount", Number(totalTaxAmount).toFixed(2));
  //   let totalAmount = Number(totalTaxAmount) + Number(netAmount);
  //   setValue("totalAmount", Number(totalAmount).toFixed(2));
  // };

  // const recalculateTaxRows = useCallback(
  //   (currentRows) => {
  //     const globalNet = Number(watch("netAmount") || 0);
  //     let rows = [...currentRows];
  //     let runningBalance = globalNet;
  //     let prevTaxAmt = 0;

  //     // keep netAmount/amount blank unless explicitly set or tax selected
  //     rows = rows.map((r) => ({
  //       ...r,
  //       netAmount:
  //         r.netAmount !== undefined &&
  //         r.netAmount !== null &&
  //         r.netAmount !== ""
  //           ? r.netAmount
  //           : r.taxId
  //           ? globalNet.toFixed(2)
  //           : "",

  //       // don't coerce empty to "0.00" here — preserve empty for no-tax rows
  //       amount: r.amount ?? "",
  //       taxRate: r.taxRate ?? r.taxRate,
  //     }));

  //     for (let i = 0; i < rows.length; i++) {
  //       const row = rows[i];

  //       // If no tax selected, preserve manual amount (if provided) and keep amount blank otherwise.
  //       if (!row.taxId) {
  //         rows[i] = {
  //           ...row,
  //           amount:
  //             row.amount !== "" && row.amount !== undefined
  //               ? Number(row.amount).toFixed(2)
  //               : "", // <-- KEEP EMPTY instead of "0.00"
  //           balance: runningBalance.toFixed(2),
  //         };
  //         continue;
  //       }

  //       const tax = taxCategoryOptions.find((t) => t.Id == row.taxId);
  //       if (!tax) {
  //         rows[i] = {
  //           ...row,
  //           amount:
  //             row.amount !== "" && row.amount !== undefined
  //               ? Number(row.amount).toFixed(2)
  //               : "", // <-- KEEP EMPTY
  //           balance: runningBalance.toFixed(2),
  //         };
  //         continue;
  //       }

  //       // If tax says repeat prev tax amt, copy netAmount from previous row (if exists)
  //       if (tax.calculated_on === "REPEAT PREV. TAX AMT" && i > 0) {
  //         rows[i] = {
  //           ...rows[i],
  //           netAmount: rows[i - 1].netAmount,
  //         };
  //       }

  //       // DISCOUNT
  //       if (tax.tax_type === "DISCOUNT") {
  //         const base = Number(rows[i].netAmount || runningBalance);
  //         const rate =
  //           row.taxRate !== undefined && row.taxRate !== ""
  //             ? Number(row.taxRate)
  //             : Number(tax.tax_rate) || 0;

  //         const manualAmountProvided =
  //           row.amount !== undefined &&
  //           row.amount !== "" &&
  //           !Number.isNaN(Number(row.amount));

  //         let discountAmt;
  //         if (rate === 0 && manualAmountProvided) {
  //           discountAmt = Number(row.amount);
  //         } else {
  //           discountAmt = (base * rate) / 100;
  //         }

  //         discountAmt = getRoundedTaxAmount(tax.round_off_type, discountAmt);
  //         const newBal = (base - Number(discountAmt)).toFixed(2);
  //         runningBalance = Number(newBal);
  //         prevTaxAmt = Number(discountAmt);

  //         rows[i] = {
  //           ...row,
  //           taxType: tax.tax_type,
  //           taxCode: tax.tax_code,
  //           taxName: tax.tax_name,
  //           taxRate: rate,
  //           calculated: tax.calculated,
  //           calculatedOn: tax.calculated_on,
  //           roundOffType: tax.round_off_type,
  //           salesLiablityAccount: tax.salesLiablityAccount,
  //           salesLiablityId: tax.salesLiablityId,
  //           amount: Number(discountAmt).toFixed(2),
  //           balance: newBal,
  //         };

  //         if (i + 1 < rows.length) {
  //           rows[i + 1] = {
  //             ...rows[i + 1],
  //             netAmount: newBal,
  //           };
  //         }
  //         continue;
  //       }

  //       // NORMAL TAX (unchanged logic after we ensure tax is present)
  //       let base = 0;
  //       const rowNet = Number(rows[i].netAmount || runningBalance);
  //       if (tax.calculated_on === "ON GROSS AMOUNT") {
  //         base = rowNet;
  //       } else if (tax.calculated_on === "BALANCE AMOUNT") {
  //         base = runningBalance;
  //       } else if (tax.calculated_on === "REPEAT PREV. TAX AMT") {
  //         base = prevTaxAmt;
  //       } else {
  //         base = rowNet;
  //       }

  //       let taxAmt;
  //       if (tax.tax_rate) {
  //         taxAmt = (base * tax.tax_rate) / 100;
  //       } else {
  //         taxAmt = Number(row.amount || 0);
  //       }

  //       taxAmt = getRoundedTaxAmount(tax.round_off_type, taxAmt);
  //       const newBal = getBalanceAmount(tax.calculated, runningBalance, taxAmt);
  //       runningBalance = Number(newBal);
  //       prevTaxAmt = Number(taxAmt);

  //       rows[i] = {
  //         ...row,
  //         taxType: tax.tax_type,
  //         taxCode: tax.tax_code,
  //         taxName: tax.tax_name,
  //         taxRate: tax.tax_rate,
  //         calculated: tax.calculated,
  //         calculatedOn: tax.calculated_on,
  //         roundOffType: tax.round_off_type,
  //         salesLiablityAccount: tax.salesLiablityAccount,
  //         salesLiablityId: tax.salesLiablityId,
  //         amount: Number(taxAmt).toFixed(2),
  //         balance: newBal,
  //       };
  //     }

  //     return rows;
  //   },
  //   [taxCategoryOptions, watch]
  // );
  const recalculateTaxRows = useCallback(
    (currentRows) => {
      const globalNet = Number(watch("netAmount") || 0);
      let rows = [...currentRows];

      rows = rows.map((r) => ({
        ...r,
        netAmount:
          r.netAmount !== undefined && r.netAmount !== null && r.netAmount !== ""
            ? r.netAmount
            : r.taxId
              ? globalNet.toFixed(2)
              : "",
        amount: r.taxRate ? (r.netAmount * r.taxRate) / 100 : r.amount,
        taxRate: r.taxRate ?? r.taxRate,
      }));

      let runningBalance =
        rows[0]?.netAmount !== "" && rows[0]?.netAmount !== undefined
          ? Number(rows[0].netAmount)
          : globalNet;

      let prevTaxAmt = 0;

      for (let i = 0; i < rows.length; i++) {
        const row = rows[i];

        const rowManualNet =
          row.netAmount !== "" && row.netAmount !== undefined
            ? Number(row.netAmount)
            : null;

        if (!row.taxId) {
          rows[i] = {
            ...row,
            amount:
              row.amount !== "" && row.amount !== undefined
                ? Number(row.amount).toFixed(2)
                : "",
            balance: runningBalance.toFixed(2),
          };
          continue;
        }

        const tax = taxCategoryOptions.find((t) => t.Id == row.taxId);
        if (!tax) continue;

        const rowRate =
          row.taxRate !== undefined && row.taxRate !== "" && row.taxRate !== null
            ? Number(row.taxRate)
            : Number(tax.tax_rate) || 0;

        if (tax.tax_type === "DISCOUNT" || tax.tax_type === "OTHERS") {
          const prevBalance =
            i === 0 ? globalNet : Number(rows[i - 1].balance || globalNet);
          rows[i] = {
            ...rows[i],
            netAmount: prevBalance.toFixed(2),
          };
        }

        if ((tax.calculated_on == "REPEAT PREV. TAX AMT" || tax.calculated_on == "REPEAT PREV.TAX AMT") && i > 0) {
          rows[i] = { ...rows[i], netAmount: rows[i - 1].netAmount };
        }

        if (tax.tax_type === "DISCOUNT") {
          const base =
            i === 0 ? globalNet : Number(rows[i - 1].balance || globalNet);

          const manualAmountProvided =
            row.amount !== undefined &&
            row.amount !== "" &&
            !Number.isNaN(Number(row.amount));

          let discountAmt = manualAmountProvided
            ? Number(row.amount)
            : (base * rowRate) / 100;

          discountAmt = getRoundedTaxAmount(tax.round_off_type, discountAmt);

          const newBal = (base - Number(discountAmt)).toFixed(2);
          runningBalance = Number(newBal);
          prevTaxAmt = Number(discountAmt);

          rows[i] = {
            ...row,
            netAmount: base.toFixed(2),
            taxType: tax.tax_type,
            taxCode: tax.tax_code,
            taxName: tax.tax_name,
            taxRate: rowRate,
            calculated: tax.calculated,
            calculatedOn: tax.calculated_on,
            roundOffType: tax.round_off_type,
            salesLiablityAccount: tax.salesLiablityAccount,
            salesLiablityId: tax.salesLiablityId,
            amount: Number(discountAmt).toFixed(2),
            balance: newBal,
          };

          if (i + 1 < rows.length) {
            rows[i + 1] = { ...rows[i + 1], netAmount: newBal };
          }
          continue;
        }

        // NORMAL TAX
        let base = 0;
        const rowNet = rowManualNet !== null ? rowManualNet : globalNet;

        if (tax.calculated_on == "ON GROSS AMOUNT") {
          base = rowNet;
        } else if (tax.calculated_on == "BALANCE AMOUNT") {
          base = i === 0 ? globalNet : Number(rows[i - 1].balance || globalNet);
        } else if (tax.calculated_on == "REPEAT PREV. TAX AMT" || tax.calculated_on == "REPEAT PREV.TAX AMT") {
          base = prevTaxAmt;
        } else {
          base = rowNet;
        }

        const manualAmountProvided =
          row.amount !== undefined &&
          row.amount !== "" &&
          !Number.isNaN(Number(row.amount));

        let taxAmt = manualAmountProvided
          ? Number(row.amount)
          : rowRate
            ? (base * rowRate) / 100
            : 0;

        taxAmt = getRoundedTaxAmount(tax.round_off_type, taxAmt);

        const prevBalance =
          i === 0 ? globalNet : Number(rows[i - 1].balance || globalNet);
        const newBal = getBalanceAmount(tax.calculated, prevBalance, taxAmt);
        runningBalance = Number(newBal);
        prevTaxAmt = Number(taxAmt);

        const netAmountForRow =
          tax.tax_type === "OTHERS"
            ? prevBalance.toFixed(2)
            : rows[i].netAmount;

        rows[i] = {
          ...row,
          netAmount: netAmountForRow,
          taxType: tax.tax_type,
          taxCode: tax.tax_code,
          taxName: tax.tax_name,
          taxRate: rowRate,
          calculated: tax.calculated,
          calculatedOn: tax.calculated_on,
          roundOffType: tax.round_off_type,
          salesLiablityAccount: tax.salesLiablityAccount,
          salesLiablityId: tax.salesLiablityId,
          amount: Number(taxAmt).toFixed(2),
          balance: newBal,
        };
      }

      return rows;
    },
    [taxCategoryOptions, watch]
  );

  const addTaxRow = () => {
    setTaxRow((prev) => {
      const netAmount = Number(watch("netAmount") || 0);
      const lastRow = prev[prev.length - 1];
      const lastBalance = lastRow ? Number(lastRow.balance) : netAmount;

      const newRow = {
        id: Math.random(),
        taxId: "",
        taxType: "",
        taxCode: "",
        taxName: "",
        netAmount: "",
        taxRate: "",
        amount: "",
        balance: lastBalance.toFixed(2),
        calculated: "",
        calculatedOn: "",
        roundOffType: "",
        salesLiablityAccount: "",
        salesLiablityId: "",
      };

      const newRows = [...prev, newRow];
      return recalculateTaxRows(newRows);
    });
  };

  // Alt+N adds a new tax row, same as clicking the "+" button
  useEffect(() => {
    const handleAddRowShortcut = (e) => {
      if (e.altKey && (e.key === "n" || e.key === "N")) {
        e.preventDefault();
        addTaxRow();
      }
    };
    window.addEventListener("keydown", handleAddRowShortcut);
    return () => window.removeEventListener("keydown", handleAddRowShortcut);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addTaxRow]);

  // Alt+R removes the last tax row, same as clicking the "-" button
  useEffect(() => {
    const handleRemoveRowShortcut = (e) => {
      if (e.altKey && (e.key === "r" || e.key === "R")) {
        e.preventDefault();
        if (taxRow?.length > 1) {
          removeTaxRow(taxRow[taxRow.length - 1].id);
        }
      }
    };
    window.addEventListener("keydown", handleRemoveRowShortcut);
    return () => window.removeEventListener("keydown", handleRemoveRowShortcut);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taxRow]);


  const removeTaxRow = (id) => {
    setTaxRow((prev) => {
      const filtered = prev.filter((row) => row.id !== id);
      return recalculateTaxRows(filtered);
    });
  };

  // const getRoundedTaxAmount = (round_off_type, amount) => {
  //   switch (round_off_type) {
  //     case "NEARER TO RUPEE":
  //       amount = Math.round(amount);
  //       break;
  //     case "NEARER TO RUPEE (UPPER SIDE)":
  //       amount = Math.ceil(amount);
  //       break;
  //     case "NEARER TO RUPEE (LOWER SIDE)":
  //       amount = Math.floor(amount);
  //       break;
  //     default:
  //       amount = amount;
  //   }
  //   return Number(amount).toFixed(2);
  // };

  // const getBalanceAmount = (type, balance, taxAmount) => {
  //   switch (type) {
  //     case "ADD":
  //       balance = (Number(balance) + Number(taxAmount)).toFixed(2);
  //       break;
  //     case "DEDUCT":
  //       balance = (Number(balance) - Number(taxAmount)).toFixed(2);
  //       break;
  //     case "IGNORE":
  //       balance = balance;
  //       break;
  //     default:
  //       balance = balance;
  //   }
  //   return Number(balance).toFixed(2);
  // };

  const getRoundedTaxAmount = (round_off_type, amount) => {
    const numAmount = Number(amount);
    switch (round_off_type) {
      case "NEARER TO RUPEE":
        return Math.round(numAmount).toFixed(2);
      case "NEARER TO RUPEE (UPPER SIDE)":
        return Math.ceil(numAmount).toFixed(2);
      case "NEARER TO RUPEE (LOWER SIDE)":
        return Math.floor(numAmount).toFixed(2);
      default:
        return numAmount.toFixed(2);
    }
  };

  // Helper: Balance Calculation
  const getBalanceAmount = (type, prevBalance, taxAmount) => {
    const numPrevBalance = Number(prevBalance);
    const numTaxAmount = Number(taxAmount);
    switch (type) {
      case "ADD":
        return (numPrevBalance + numTaxAmount).toFixed(2);
      case "DEDUCT":
        return (numPrevBalance - numTaxAmount).toFixed(2);
      case "IGNORE":
        return numPrevBalance.toFixed(2);
      default:
        return numPrevBalance.toFixed(2);
    }
  };

  useEffect(() => {
    const netAmount = watch("netAmount");
    if (netAmount === undefined || netAmount === "") return;
    // Only recalculate if not in edit mode
    if (!editId) {
      setTaxRow((prev) => recalculateTaxRows(prev));
    }
  }, [watch("netAmount"), editId]);

  useEffect(() => {
    let netAmount = watch("netAmount");
    let displayNetAmount = watch("netAmount");
    let totalTaxAmount = 0;
    let balance = watch("netAmount");

    let previousTaxAmount = 0;
    taxRow?.map((row, index) => {
      if (row?.taxId) {
        const tax = taxCategoryOptions?.find((ele) => ele?.Id == row?.taxId);
        if (
          (watch("salesType") == "Local" && tax?.tax_type != "I.GST") ||
          (watch("salesType") != "Local" &&
            tax?.tax_type != "S.GST" &&
            tax?.tax_type != "C.GST")
        ) {
          let taxAmount = 0;
          if (tax?.tax_rate) {
            if (tax?.calculated_on == "ON GROSS AMOUNT") {
              taxAmount = ((displayNetAmount * tax?.tax_rate) / 100).toFixed(2);
            } else if (tax?.calculated_on == "BALANCE AMOUNT") {
              taxAmount = ((balance * tax?.tax_rate) / 100).toFixed(2);
            } else if (tax?.calculated_on == "REPEAT PRV.TAX AMT") {
              taxAmount = previousTaxAmount;
            } else {
              taxAmount = ((displayNetAmount * tax?.tax_rate) / 100).toFixed(2);
            }
          } else {
            taxAmount = Number(row?.amount);
          }

          // Set this tax amount in previous tax amount for next row if has repeat previous tax amount previous
          previousTaxAmount = taxAmount;

          // get amount on base of rounded type define in tax master
          taxAmount = getRoundedTaxAmount(tax?.round_off_type, taxAmount);
          balance = getBalanceAmount(
            tax?.calculated,
            Number(balance),
            Number(taxAmount || 0),
          );

          if (tax?.calculated != "DEDUCT") {
            totalTaxAmount += Number(taxAmount);
          }
          const obj = {
            id: row?.id || Math.random(),
            taxId: row?.taxId,
            taxType: tax?.tax_type,
            taxCode: tax?.tax_code,
            taxName: tax?.tax_name,
            netAmount: Number(displayNetAmount).toFixed(2),
            taxRate: tax?.tax_rate,
            amount: taxAmount,
            balance: balance,
            calculated: tax?.calculated,
            calculatedOn: tax?.calculated_on,
            roundOffType: tax?.round_off_type,
            salesLiablityAccount: tax?.salesLiablityAccount,
            salesLiablityId: tax?.salesLiablityId,
          };
          setTaxRow((data) => {
            let arr = [...data];
            arr[index] = obj;
            return arr;
          });
          if (tax?.tax_type == "OTHERS") {
            displayNetAmount = Number(
              Number(displayNetAmount) + Number(taxAmount),
            );
          }
        }
      }
    });
    setValue("totalTaxAmount", Number(totalTaxAmount).toFixed(2));
    let totalAmount = Number(totalTaxAmount) + Number(netAmount);
    setValue("totalAmount", Number(totalAmount).toFixed(2));
  }, [watch("netAmount")]);

  // const handleChangeTaxData = (index, key, value) => {
  //   if (!value || value == "undefined") {
  //     setTaxRow((data) => {
  //       let arr = [...data];
  //       arr[index][key] = value;
  //       arr[index]["amount"] = 0.0;
  //       arr[index]["balance"] = Number(arr[index]["netAmount"]);
  //       return arr;
  //     });
  //   } else {
  //     setTaxRow((data) => {
  //       let arr = [...data];
  //       arr[index][key] = value;
  //       return arr;
  //     });

  //     let netAmount = watch("netAmount");
  //     let displayNetAmount = watch("netAmount");
  //     let totalTaxAmount = 0;
  //     let balance = watch("netAmount");

  //     let previousTaxAmount = 0;
  //     taxRow?.map((row, index) => {
  //       if (row?.taxId) {
  //         const tax = taxCategoryOptions?.find((ele) => ele?.Id == row?.taxId);
  //         if (
  //           (watch("salesType") == "Local" && tax?.tax_type != "I.GST") ||
  //           (watch("salesType") != "Local" &&
  //             tax?.tax_type != "S.GST" &&
  //             tax?.tax_type != "C.GST")
  //         ) {
  //           let taxAmount = 0;
  //           if (tax?.tax_rate) {
  //             if (tax?.calculated_on == "ON GROSS AMOUNT") {
  //               taxAmount = ((displayNetAmount * tax?.tax_rate) / 100).toFixed(
  //                 2
  //               );
  //             } else if (tax?.calculated_on == "BALANCE AMOUNT") {
  //               taxAmount = ((balance * tax?.tax_rate) / 100).toFixed(2);
  //             } else if (tax?.calculated_on == "REPEAT PRV.TAX AMT") {
  //               taxAmount = previousTaxAmount;
  //             } else {
  //               taxAmount = ((displayNetAmount * tax?.tax_rate) / 100).toFixed(
  //                 2
  //               );
  //             }
  //           } else {
  //             taxAmount = Number(row?.amount);
  //           }

  //           // Set this tax amount in previous tax amount for next row if has repeat previous tax amount previous
  //           previousTaxAmount = taxAmount;

  //           // get amount on base of rounded type define in tax master
  //           taxAmount = getRoundedTaxAmount(tax?.round_off_type, taxAmount);
  //           balance = getBalanceAmount(
  //             tax?.calculated,
  //             Number(balance),
  //             Number(taxAmount || 0)
  //           );

  //           if (tax?.calculated != "DEDUCT") {
  //             totalTaxAmount += Number(taxAmount);
  //           }
  //           const obj = {
  //             id: Math.random(),
  //             taxId: row?.taxId,
  //             taxType: tax?.tax_type,
  //             taxCode: tax?.tax_code,
  //             taxName: tax?.tax_name,
  //             netAmount: Number(displayNetAmount).toFixed(2),
  //             taxRate: tax?.tax_rate,
  //             amount: taxAmount,
  //             balance: balance,
  //             calculated: tax?.calculated,
  //             calculatedOn: tax?.calculated_on,
  //             roundOffType: tax?.round_off_type,
  //             salesLiablityAccount: tax?.salesLiablityAccount,
  //             salesLiablityId: tax?.salesLiablityId,
  //           };
  //           setTaxRow((data) => {
  //             let arr = [...data];
  //             arr[index] = obj;
  //             return arr;
  //           });
  //           if (tax?.tax_type == "OTHERS") {
  //             displayNetAmount = Number(
  //               Number(displayNetAmount) + Number(taxAmount)
  //             );
  //           }
  //         }
  //       }
  //     });
  //     setValue("totalTaxAmount", Number(totalTaxAmount).toFixed(2));
  //     let totalAmount = Number(totalTaxAmount) + Number(netAmount);
  //     setValue("totalAmount", Number(totalAmount).toFixed(2));
  //   }
  // };

  const handleChangeTaxData = (index, key, value) => {
    if (!value || value === "undefined") {
      setTaxRow((prev) => {
        const newRows = [...prev];
        newRows[index] = {
          ...newRows[index],
          taxId: "",
          taxType: "",
          taxCode: "",
          taxName: "",
          taxRate: "",
          calculated: "",
          calculatedOn: "",
          amount: "0.00",
          balance: newRows[index].balance || "0.00",
        };
        return recalculateTaxRows(newRows);
      });
      return;
    }

    const tax = taxCategoryOptions?.find((ele) => ele?.Id == value);
    if (tax) {
      setTaxRow((prev) => {
        const newRows = [...prev];
        const mainNetAmount = Number(watch("netAmount") || 0);

        let netAmountToUse = mainNetAmount.toFixed(2);

        if (tax.tax_type === "DISCOUNT" || tax.tax_type === "OTHERS") {
          if (index > 0) {
            netAmountToUse = newRows[index - 1]?.balance || mainNetAmount.toFixed(2);
          } else {
            netAmountToUse = mainNetAmount.toFixed(2);
          }
        } else if (tax.calculated_on == "ON GROSS AMOUNT") {
          if (index > 0) {
            netAmountToUse = newRows[index - 1]?.balance || mainNetAmount.toFixed(2);
          } else {
            netAmountToUse = mainNetAmount.toFixed(2);
          }
        } else if (tax.calculated_on == "BALANCE AMOUNT") {
          if (index > 0) {
            netAmountToUse = newRows[index - 1]?.balance || mainNetAmount.toFixed(2);
          } else {
            netAmountToUse = mainNetAmount.toFixed(2);
          }
        } else if (
          tax.calculated_on == "REPEAT PREV.TAX AMT" ||
          tax.calculated_on == "REPEAT PREV. TAX AMT"
        ) {
          if (index > 0) {
            netAmountToUse = newRows[index - 1]?.netAmount || mainNetAmount.toFixed(2);
          } else {
            netAmountToUse = mainNetAmount.toFixed(2);
          }
        } else if (index > 0) {
          const prevRow = newRows[index - 1];
          if (prevRow.taxId) {
            const prevTax = taxCategoryOptions?.find(
              (ele) => ele?.Id == prevRow.taxId
            );
            if (
              prevTax &&
              (prevTax.calculated_on == "REPEAT PREV.TAX AMT" ||
                prevTax.calculated_on == "REPEAT PREV. TAX AMT")
            ) {
              netAmountToUse = prevRow.netAmount;
            }
          }
        }

        const rowNetAmount = Number(netAmountToUse);
        let baseAmount = rowNetAmount;
        let initialBalance = rowNetAmount;

        if (index === 0) {
          baseAmount = rowNetAmount;
          initialBalance = rowNetAmount;
        } else {
          if (tax.calculated_on == "BALANCE AMOUNT") {
            baseAmount = Number(newRows[index - 1].balance) || rowNetAmount;
            initialBalance = baseAmount;
          } else if (
            tax.calculated_on == "REPEAT PREV.TAX AMT" ||
            tax.calculated_on == "REPEAT PREV. TAX AMT"
          ) {
            baseAmount = Number(newRows[index - 1].amount) || 0;
            initialBalance = Number(newRows[index - 1].balance) || rowNetAmount;
          } else if (tax.calculated_on == "ON GROSS AMOUNT") {
            baseAmount = Number(newRows[index - 1].balance) || rowNetAmount;
            initialBalance = Number(newRows[index - 1].balance) || rowNetAmount;
          } else {
            baseAmount = rowNetAmount;
            initialBalance = Number(newRows[index - 1].balance) || rowNetAmount;
          }
        }

        let initialTaxAmount = 0;
        if (tax.tax_rate) {
          const rawAmount = (baseAmount * tax.tax_rate) / 100;
          const roundedAmount = getRoundedTaxAmount(
            tax.round_off_type || "undefined",
            rawAmount
          );
          initialTaxAmount = Number(roundedAmount);
        }

        let finalBalance = getBalanceAmount(
          tax.calculated,
          initialBalance,
          initialTaxAmount
        );

        newRows[index] = {
          ...newRows[index],
          netAmount: netAmountToUse,
          taxId: value,
          taxType: tax.tax_type,
          taxCode: tax.tax_code,
          taxName: tax.tax_name,
          taxRate: tax.tax_rate,
          calculated: tax.calculated,
          calculatedOn: tax.calculated_on,
          roundOffType: tax.round_off_type,
          salesLiablityAccount: tax.salesLiablityAccount,
          salesLiablityId: tax.salesLiablityId,
          amount: initialTaxAmount.toFixed(2),
          balance: finalBalance,
        };

        return recalculateTaxRows([...newRows]);
      });
    }
  };


  const handleChangeTaxRate = useCallback(
    (index, rateValue) => {
      setTaxRow((prev) => {
        const newRows = [...prev];
        newRows[index] = {
          ...newRows[index],
          taxRate: rateValue,
        };
        return recalculateTaxRows(newRows);
      });
    },
    [recalculateTaxRows],
  );


  // const handleChangeChargeData = (index, key, value) => {
  //   setTaxRow((data) => {
  //     let arr = [...data];
  //     arr[index]["amount"] = Number(value) || 0;
  //     // arr[index]["balance"] = Number(
  //     //   Number(value) + Number(arr[index - 1]["balance"]) || 0
  //     // ).toFixed(2);
  //     arr[index]["balance"] = Number(
  //       Number(value) +
  //         (Number(arr[index - 1]?.["balance"]) || Number(watch("netAmount")))
  //     ).toFixed(2);
  //     return arr;
  //   });

  //   let netAmount = watch("netAmount");
  //   let totalTaxAmount = 0;
  //   let balance = watch("netAmount");

  //   let previousTaxAmount = 0;
  //   taxRow?.map((row, index) => {
  //     if (row?.taxId) {
  //       const tax = taxCategoryOptions?.find((ele) => ele?.Id == row?.taxId);
  //       if (
  //         (watch("salesType") == "Local" && tax?.tax_type != "I.GST") ||
  //         (watch("salesType") != "Local" &&
  //           tax?.tax_type != "S.GST" &&
  //           tax?.tax_type != "C.GST")
  //       ) {
  //         let taxAmount = 0;
  //         if (tax?.tax_rate) {
  //           if (tax?.calculated_on == "ON GROSS AMOUNT") {
  //             taxAmount = ((netAmount * tax?.tax_rate) / 100).toFixed(2);
  //           } else if (tax?.calculated_on == "BALANCE AMOUNT") {
  //             taxAmount = ((balance * tax?.tax_rate) / 100).toFixed(2);
  //           } else if (tax?.calculated_on == "REPEAT PRV.TAX AMT") {
  //             taxAmount = previousTaxAmount;
  //           } else {
  //             taxAmount = ((netAmount * tax?.tax_rate) / 100).toFixed(2);
  //           }
  //         } else {
  //           taxAmount = Number(row?.amount);
  //         }

  //         // Set this tax amount in previous tax amount for next row if has repeat previous tax amount previous
  //         previousTaxAmount = taxAmount;

  //         // get amount on base of rounded type define in tax master
  //         taxAmount = getRoundedTaxAmount(tax?.round_off_type, taxAmount);
  //         balance = getBalanceAmount(
  //           tax?.calculated,
  //           Number(balance),
  //           Number(taxAmount || 0)
  //         );

  //         if (tax?.calculated != "DEDUCT") {
  //           totalTaxAmount += Number(taxAmount);
  //         }
  //         const obj = {
  //           id: Math.random(),
  //           taxId: row?.taxId,
  //           taxCode: tax?.tax_code,
  //           taxName: tax?.tax_name,
  //           netAmount: Number(netAmount).toFixed(2),
  //           taxRate: tax?.tax_rate,
  //           amount: taxAmount,
  //           balance: balance,
  //           calculated: tax?.calculated,
  //           calculatedOn: tax?.calculated_on,
  //           roundOffType: tax?.round_off_type,
  //           salesLiablityAccount: tax?.salesLiablityAccount,
  //           salesLiablityId: tax?.salesLiablityId,
  //         };
  //       }
  //     }
  //   });
  //   setValue("totalTaxAmount", Number(totalTaxAmount).toFixed(2));
  //   let totalAmount = Number(totalTaxAmount) + Number(netAmount);
  //   setValue("totalAmount", Number(totalAmount).toFixed(2));
  // };
  const handleChangeRowNetAmount = (index, value) => {
    const parsed = Number(value);
    const hasValidNumber = !Number.isNaN(parsed) && value !== "";

    setTaxRow((prev) => {
      const newRows = [...prev];
      newRows[index] = {
        ...newRows[index],
        netAmount: value,
        amount: "", // reset so recalculate does fresh calc
      };
      return recalculateTaxRows(newRows);
    });
  };

  const handleChangeChargeData = (index, key, value) => {
    const parsed = Number(value);
    const hasValidNumber = !Number.isNaN(parsed);

    setTaxRow((prev) => {
      const newRows = [...prev];
      newRows[index] = {
        ...newRows[index],
        amount: hasValidNumber ? parsed.toFixed(2) : value,
      };
      return recalculateTaxRows(newRows);
    });
  };

  // Calculate Totals
  useEffect(() => {
    let totalTaxAmount = 0;
    taxRow.forEach((row) => {
      if (
        row.taxType !== "OTHERS" &&
        row.calculated !== "DEDUCT" &&
        row.amount
      ) {
        totalTaxAmount += Number(row.amount);
      }
    });

    const netAmount = Number(watch("netAmount") || 0);
    const lastRowBalance = taxRow?.length > 0
      ? Number(taxRow[taxRow.length - 1]?.balance || 0)
      : netAmount;

    setValue("totalTaxAmount", totalTaxAmount.toFixed(2));
    setValue("totalAmount", lastRowBalance.toFixed(2));
  }, [taxRow, watch("netAmount"), setValue]);

  if (loading) {
    <LoadingSpinner />;
  } else {
    return (
      <div>
        <Index.Box className="main_content">
          <Index.Box className="page-title-main">
            <Index.Box className="flex-justify">
              <Index.Typography variant="h4" component="h4">
                Purchase Voucher Entry
              </Index.Typography>
            </Index.Box>
          </Index.Box>
          <Index.Box className="web-main-content">
            <Index.Box className="over-text-scroll">
              <Index.Box className="admin-dashboard-list-row">
                <form className="form-content" onSubmit={handleSubmit(submit)}>
                  <Index.Box className="report-main-box report-main-box-set">
                    <Index.Box sx={{ width: 1 }} className="grid-main">
                      <Index.Box
                        display="grid"
                        className="display-row"
                        gridTemplateColumns="repeat(12, 1fr)"
                        gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                      >
                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 12",
                            md: "span 12",
                            lg: "span 12",
                          }}
                          className="grid-column"
                        >
                          <Item className="grid-item">
                            <Index.Box className="input-box">
                              <Index.Box className="form-group">
                                <Index.FormHelperText className="lable-control">
                                  Type <span className="requried-star">*</span>
                                </Index.FormHelperText>
                                <RadioGroup
                                  row
                                  aria-labelledby="demo-row-radio-buttons-group-label"
                                  name="row-radio-buttons-group"
                                  className="radio-group"
                                  value={watch("accountType")}
                                  onChange={(e, value) => {
                                    setValue("accountType", value);
                                    setValue("salesAccountId", "");
                                  }}
                                >
                                  <FormControlLabel
                                    value="purchase"
                                    checked={watch("accountType") == "purchase"}
                                    control={<Radio />}
                                    label="Purchase"
                                    className="radio-control"
                                  />
                                  <FormControlLabel
                                    value="expenses"
                                    checked={watch("accountType") == "expenses"}
                                    control={<Radio />}
                                    label="Expenses"
                                    className="radio-control"
                                  />
                                </RadioGroup>
                              </Index.Box>
                            </Index.Box>
                          </Item>
                        </Index.Box>

                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 4",
                            md: "span 4",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Item className="grid-item">
                            <Index.Box className="input-box">
                              <Index.Box className="form-group">
                                <Index.FormHelperText className="lable-control">
                                  {`${watch("accountType") == "purchase"
                                    ? "Purchase"
                                    : "Expense"
                                    } A/C`}{" "}
                                  <span className="requried-star">*</span>
                                </Index.FormHelperText>
                                <Index.Box className="dropdown-box auto-drop-box">
                                  <Controller
                                    control={control}
                                    {...register("salesAccountId", {
                                      required: "Purchase account is required.",
                                    })}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <Autocomplete
                                        className="custom-form-control"
                                        value={
                                          value
                                            ? (watch("accountType") ==
                                              "purchase"
                                              ? purchaseAccount
                                              : expenseAccount
                                            )?.find((o) => o.id === value)
                                            : value || null
                                        }
                                        options={
                                          (watch("accountType") == "purchase"
                                            ? purchaseAccount
                                            : expenseAccount) || []
                                        }
                                        autoHighlight
                                        onChange={(e, value) => {
                                          onChange(value?.id ? value?.id : "");
                                        }}
                                        getOptionLabel={(option) =>
                                          `${option?.accountName}(${option?.GroupName})`
                                        }
                                        renderOption={(props, option) => (
                                          <Index.Box
                                            component="li"
                                            sx={{
                                              "& > img": {
                                                mr: 2,
                                                flexShrink: 0,
                                              },
                                            }}
                                            {...props}
                                          >
                                            {`${option?.accountName}(${option?.GroupName})`}
                                          </Index.Box>
                                        )}
                                        renderInput={(params) => (
                                          <Index.TextField
                                            fullWidth
                                            error={Boolean(
                                              errors?.salesAccountId,
                                            )}
                                            className="inner-custom-form-control"
                                            {...params}
                                            size="small"
                                            variant="outlined"
                                          />
                                        )}
                                      />
                                    )}
                                  />
                                </Index.Box>
                              </Index.Box>
                            </Index.Box>
                          </Item>
                        </Index.Box>

                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 4",
                            md: "span 4",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Item className="grid-item">
                            <Index.Box className="input-box">
                              <Index.Box className="form-group">
                                <Index.FormHelperText className="lable-control">
                                  Invoice No.{" "}
                                  <span className="requried-star">*</span>
                                </Index.FormHelperText>
                                <Index.TextField
                                  fullWidth
                                  id="fullWidth"
                                  className="custom-form-control"
                                  // disabled={editId ? true : false}
                                  value={watch("voucherNo")}
                                  {...register("voucherNo", {
                                    required: "Invoice no is required.",
                                  })}
                                  // inputProps={{ maxLength: 10 }}
                                  // onBlur={(e) =>
                                  //   setValue(
                                  //     "voucherNo",
                                  //     generateInvoiceNumber(e.target.value)
                                  //   )
                                  // }
                                  onChange={(e) =>
                                    setValue(
                                      "voucherNo",
                                      e.target.value.toUpperCase(),
                                    )
                                  }
                                  error={Boolean(errors.voucherNo)}
                                />
                              </Index.Box>
                            </Index.Box>
                          </Item>
                        </Index.Box>
                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 4",
                            md: "span 4",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Item className="grid-item">
                            <Index.Box className="input-box">
                              <Index.Box className="form-group date-of-purchase">
                                <Index.FormHelperText className="lable-control">
                                  Invoice Date{" "}
                                  <span className="requried-star">*</span>
                                </Index.FormHelperText>

                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <DemoContainer components={["DatePicker"]}>
                                    <Controller
                                      control={control}
                                      {...register("voucherDate", {
                                        required: "Invoice date is required.",
                                      })}
                                      render={({
                                        field: { onChange, value },
                                      }) => (
                                        <MobileDatePicker
                                          // disableFuture={true}
                                          className="custom-form-control"
                                          minDate={dayjs(selectedYearStart)}
                                          maxDate={dayjs(selectedYearEnd)}
                                          format="DD/MM/YYYY"
                                          value={value}
                                          onChange={(newValue) => {
                                            setValue("voucherDate", newValue);
                                          }}
                                          slotProps={{
                                            textField: {
                                              size: "small",
                                              error: Boolean(
                                                errors.voucherDate,
                                              ),
                                              // error : true
                                            },
                                          }}
                                          error={Boolean(errors.voucherDate)}
                                        />
                                      )}
                                    />
                                  </DemoContainer>
                                </LocalizationProvider>
                              </Index.Box>
                            </Index.Box>
                          </Item>
                        </Index.Box>
                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 6",
                            md: "span 4",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Item className="grid-item">
                            <Index.Box className="input-box">
                              <Index.Box className="form-group">
                                <Index.FormHelperText className="lable-control">
                                  Party <span className="requried-star">*</span>
                                </Index.FormHelperText>
                                <Index.Box className="dropdown-box auto-drop-box">
                                  <Controller
                                    control={control}
                                    {...register("party", {
                                      required: "Party is required.",
                                    })}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <Autocomplete
                                        className="custom-form-control"
                                        value={
                                          value
                                            ? sundryCreditors?.find(
                                              (o) => o.id === value,
                                            )
                                            : value || null
                                        }
                                        options={sundryCreditors || []}
                                        autoHighlight
                                        disabled={editId ? true : false}
                                        onChange={(e, value) => {
                                          onChange(value?.id ? value?.id : "");
                                          setBrokerOfParty(value?.id);
                                        }}
                                        getOptionLabel={(option) =>
                                          option?.accountName
                                        }
                                        renderOption={(props, option) => (
                                          <Index.Box
                                            component="li"
                                            sx={{
                                              "& > img": {
                                                mr: 2,
                                                flexShrink: 0,
                                              },
                                            }}
                                            {...props}
                                          >
                                            {option?.accountName}
                                          </Index.Box>
                                        )}
                                        renderInput={(params) => (
                                          <Index.TextField
                                            fullWidth
                                            error={Boolean(errors?.party)}
                                            className="inner-custom-form-control"
                                            {...params}
                                            size="small"
                                            variant="outlined"
                                          />
                                        )}
                                      />
                                    )}
                                  />
                                </Index.Box>
                              </Index.Box>
                            </Index.Box>
                          </Item>
                        </Index.Box>

                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 4",
                            md: "span 4",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Item className="grid-item">
                            <Index.Box className="input-box">
                              <Index.Box className="form-group">
                                <Index.FormHelperText className="lable-control">
                                  Currency{" "}
                                  <span className="requried-star">*</span>
                                </Index.FormHelperText>
                                <Index.Box className="dropdown-box auto-drop-box">
                                  <Controller
                                    control={control}
                                    {...register("currency", {
                                      required: "Currency is required.",
                                    })}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <Autocomplete
                                        className="custom-form-control"
                                        value={
                                          value
                                            ? currencies?.find(
                                              (o) => o.id === value,
                                            )
                                            : value || null
                                        }
                                        options={currencies || []}
                                        autoHighlight
                                        onChange={(e, value) => {
                                          onChange(value?.id ? value?.id : "");
                                        }}
                                        getOptionLabel={(option) =>
                                          option?.name
                                        }
                                        renderOption={(props, option) => (
                                          <Index.Box
                                            component="li"
                                            sx={{
                                              "& > img": {
                                                mr: 2,
                                                flexShrink: 0,
                                              },
                                            }}
                                            {...props}
                                          >
                                            {option?.name}
                                          </Index.Box>
                                        )}
                                        renderInput={(params) => (
                                          <Index.TextField
                                            fullWidth
                                            error={Boolean(errors?.currency)}
                                            className="inner-custom-form-control"
                                            {...params}
                                            size="small"
                                            variant="outlined"
                                          />
                                        )}
                                      />
                                    )}
                                  />
                                </Index.Box>
                              </Index.Box>
                            </Index.Box>
                          </Item>
                        </Index.Box>

                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 4",
                            md: "span 4",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Item className="grid-item">
                            <Index.Box className="input-box">
                              <Index.Box className="form-group">
                                <Index.FormHelperText className="lable-control">
                                  Cr.Days.
                                </Index.FormHelperText>
                                <Index.TextField
                                  fullWidth
                                  type="number"
                                  id="fullWidth"
                                  className="custom-form-control"
                                  value={watch("creditDays")}
                                  {...register("creditDays")}
                                  onChange={(e) => {
                                    if (e.target.value < 0) {
                                      setValue("creditDays", 0);
                                    } else {
                                      setValue("creditDays", e.target.value);
                                    }
                                  }}
                                  error={Boolean(errors.creditDays)}
                                />
                              </Index.Box>
                            </Index.Box>
                          </Item>
                        </Index.Box>
                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 4",
                            md: "span 4",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Item className="grid-item">
                            <Index.Box className="input-box">
                              <Index.Box className="form-group">
                                <Index.FormHelperText className="lable-control">
                                  Broker
                                </Index.FormHelperText>
                                <Index.Box className="dropdown-box auto-drop-box">
                                  <Controller
                                    control={control}
                                    {...register("broker")}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <Autocomplete
                                        className="custom-form-control"
                                        value={
                                          value
                                            ? brokers?.find(
                                              (o) => o.id === value,
                                            )
                                            : value || null
                                        }
                                        options={brokers || []}
                                        autoHighlight
                                        onChange={(e, value) => {
                                          onChange(value?.id ? value?.id : "");
                                        }}
                                        getOptionLabel={(option) =>
                                          option?.accountName
                                        }
                                        renderOption={(props, option) => (
                                          <Index.Box
                                            component="li"
                                            sx={{
                                              "& > img": {
                                                mr: 2,
                                                flexShrink: 0,
                                              },
                                            }}
                                            {...props}
                                          >
                                            {option?.accountName}
                                          </Index.Box>
                                        )}
                                        renderInput={(params) => (
                                          <Index.TextField
                                            fullWidth
                                            error={Boolean(errors?.broker)}
                                            className="inner-custom-form-control"
                                            {...params}
                                            size="small"
                                            variant="outlined"
                                          />
                                        )}
                                      />
                                    )}
                                  />
                                </Index.Box>
                              </Index.Box>
                            </Index.Box>
                          </Item>
                        </Index.Box>

                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 12",
                            md: "span 12",
                            lg: "span 12",
                          }}
                          className="grid-column"
                        >
                          <Item className="grid-item">
                            <Index.Box className="input-box">
                              <Index.Box className="form-group">
                                <Index.FormHelperText className="lable-control">
                                  Remarks
                                </Index.FormHelperText>
                                <Controller
                                  control={control}
                                  {...register("note", {
                                    // required: "Remarks is required.",
                                  })}
                                  render={({ field: { onChange, value } }) => (
                                    <TextareaAutosize
                                      className={`custom_form_control_textarea ${errors?.note
                                        ? "remark-textarea-error"
                                        : ""
                                        }`}
                                      value={value}
                                      aria-label="empty textarea"
                                      placeholder=""
                                      minRows="2"
                                      error={Boolean(errors?.note)}
                                      onChange={onChange}
                                    />
                                  )}
                                />
                              </Index.Box>
                            </Index.Box>
                          </Item>
                        </Index.Box>
                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 4",
                            md: "span 4",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Item className="grid-item">
                            <Index.Box className="input-box">
                              <Index.Box className="form-group">
                                <Index.FormHelperText className="lable-control">
                                  HSN
                                </Index.FormHelperText>
                                <Index.Box className="dropdown-box auto-drop-box">
                                  <Controller
                                    control={control}
                                    {...register("hsnId")}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <Autocomplete
                                        className="custom-form-control"
                                        value={
                                          value
                                            ? hsn?.find((o) => o.id === value)
                                            : value || null
                                        }
                                        options={hsn || []}
                                        autoHighlight
                                        onChange={(e, value) => {
                                          onChange(value?.id ? value?.id : "");
                                        }}
                                        getOptionLabel={(option) =>
                                          option?.HSNCode
                                        }
                                        renderOption={(props, option) => (
                                          <Index.Box
                                            component="li"
                                            sx={{
                                              "& > img": {
                                                mr: 2,
                                                flexShrink: 0,
                                              },
                                            }}
                                            {...props}
                                          >
                                            {option?.HSNCode}
                                          </Index.Box>
                                        )}
                                        renderInput={(params) => (
                                          <Index.TextField
                                            fullWidth
                                            error={Boolean(errors?.hsnId)}
                                            className="inner-custom-form-control"
                                            {...params}
                                            size="small"
                                            variant="outlined"
                                          />
                                        )}
                                      />
                                    )}
                                  />
                                </Index.Box>
                              </Index.Box>
                            </Index.Box>
                          </Item>
                        </Index.Box>
                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 4",
                            md: "span 4",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Item className="grid-item">
                            <Index.Box className="input-box">
                              <Index.Box className="form-group">
                                <Index.FormHelperText className="lable-control">
                                  Narration
                                </Index.FormHelperText>
                                <Index.Box className="dropdown-box auto-drop-box">
                                  <Controller
                                    control={control}
                                    {...register("narration")}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <Autocomplete
                                        open={narrationDropdown}
                                        onOpen={() => {
                                          setNarrationDropdown(true);
                                        }}
                                        onClose={() =>
                                          setNarrationDropdown(false)
                                        }
                                        className="custom-form-control"
                                        options={narrationList || []}
                                        name="narration"
                                        disableClearable
                                        closeText={""}
                                        openText={""}
                                        clearText={""}
                                        value={
                                          watch("narration")
                                            ? narrationList?.find(
                                              (o) =>
                                                o.narrat ===
                                                watch("narration"),
                                            )
                                            : watch("narration") || null
                                        }
                                        onChange={(e, selectedOptions) => {
                                          if (!e.key) {
                                            setValue(
                                              "narration",
                                              selectedOptions?.narrat,
                                            );
                                          }
                                        }}
                                        renderOption={(props, item) => (
                                          // <li {...props} key={item?.narrat}>
                                          //   {item?.narrat}
                                          // </li>
                                          <ContainerIndex.Box
                                            component="li"
                                            sx={{
                                              "& > img": {
                                                mr: 2,
                                                flexShrink: 0,
                                              },
                                            }}
                                            {...props}
                                          >
                                            {item?.narrat}
                                          </ContainerIndex.Box>
                                        )}
                                        getOptionLabel={(option) =>
                                          option?.narrat
                                        }
                                        renderInput={(params) => (
                                          <ContainerIndex.TextField
                                            fullWidth
                                            className="inner-custom-form-control"
                                            {...params}
                                            size="small"
                                            variant="outlined"
                                            onKeyDown={(e) => {
                                              if (e.key === "Enter") {
                                                setNarrationDropdown(false);
                                                e.preventDefault();
                                                const existData =
                                                  narrationList.find(
                                                    (data) =>
                                                      data?.narrat?.toLowerCase() ===
                                                      e.target.value?.toLowerCase(),
                                                  );
                                                if (existData) {
                                                  setValue(
                                                    "narration",
                                                    existData,
                                                  );
                                                } else {
                                                  setNarrationList((prev) => [
                                                    ...prev,
                                                    {
                                                      narrat: e.target.value,
                                                    },
                                                  ]);
                                                  setValue(
                                                    "narration",
                                                    e.target.value,
                                                  );
                                                }
                                              }
                                            }}
                                          />
                                        )}
                                      />
                                    )}
                                  />
                                </Index.Box>
                              </Index.Box>
                            </Index.Box>
                          </Item>
                        </Index.Box>
                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 4",
                            md: "span 4",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Item className="grid-item">
                            <Index.Box className="input-box">
                              <Index.Box className="form-group">
                                <Index.FormHelperText className="lable-control">
                                  <span>Net Amount</span>
                                  <span className="requried-star">*</span>
                                </Index.FormHelperText>
                                <Index.TextField
                                  fullWidth
                                  type="number"
                                  id="fullWidth"
                                  className="custom-form-control"
                                  value={watch("netAmount")}
                                  {...register("netAmount", {
                                    required: "Net amount is required.",
                                  })}
                                  onChange={(e) => {
                                    if (e.target.value < 0) {
                                      setValue("netAmount", 0);
                                    } else {
                                      setValue("netAmount", e.target.value);
                                    }
                                  }}
                                  error={Boolean(errors.netAmount)}
                                />
                              </Index.Box>
                            </Index.Box>
                          </Item>
                        </Index.Box>

                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 4",
                            md: "span 4",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Item className="grid-item">
                            <Index.Box className="input-box">
                              <Index.Box className="form-group">
                                <Index.Box className="checkbox-content-flex">
                                  <Index.FormHelperText className="checkbox-lable">
                                    J.V of T.D.S
                                  </Index.FormHelperText>
                                  <Index.Box className="checkbox-main">
                                    <Controller
                                      control={control}
                                      {...register("jvTds")}
                                      render={({
                                        field: { onChange, value },
                                      }) => (
                                        <input
                                          type="checkbox"
                                          disabled={
                                            supplierDeductTDSStatus
                                              ? false
                                              : true
                                          }
                                          className="checkbox"
                                          checked={value}
                                          onChange={() =>
                                            setValue("jvTds", !watch("jvTds"))
                                          }
                                        />
                                      )}
                                    />
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                            </Index.Box>
                          </Item>
                        </Index.Box>

                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 4",
                            md: "span 4",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Item className="grid-item">
                            <Index.Box className="input-box">
                              <Index.Box className="form-group">
                                <Index.Box className="checkbox-content-flex">
                                  <Index.FormHelperText className="checkbox-lable">
                                    RCM
                                  </Index.FormHelperText>
                                  <Index.Box className="checkbox-main">
                                    <Controller
                                      control={control}
                                      {...register("rcm")}
                                      render={({
                                        field: { onChange, value },
                                      }) => (
                                        <input
                                          type="checkbox"
                                          className="checkbox"
                                          checked={value}
                                          onChange={() =>
                                            setValue("rcm", !watch("rcm"))
                                          }
                                        />
                                      )}
                                    />
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                            </Index.Box>
                          </Item>
                        </Index.Box>

                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 6",
                            md: "span 6",
                            lg: "span 6",
                          }}
                          className="grid-column"
                        >
                          <Item className="grid-item">
                            <Index.Box className="input-box">
                              <Index.Box className="form-group">
                                <Index.FormHelperText className="lable-control red">
                                  {watch("salesType")
                                    ? `Sales Type: ${watch("salesType")}`
                                    : ""}
                                </Index.FormHelperText>
                              </Index.Box>
                            </Index.Box>
                          </Item>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>

                  {!watch("rcm") ? (
                    <Index.Box className="common-card m-30">
                      <Index.Box className="tabs-containt-main">
                        <Index.Box className="page-table-main others-salesentry-scrollbale-table-main">
                          <TableContainer
                            component={Paper}
                            className="table-container scrollable-table-container"
                            sx={{ maxHeight: 255 }}
                          >
                            <Table
                              className="table"
                              stickyHeader
                              aria-label="sticky table"
                            >
                              <TableHead>
                                <TableRow>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    className="table-th"
                                  >
                                    <Index.Box className="scrollable-box">
                                      No.
                                    </Index.Box>
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    className="table-th"
                                  >
                                    <Index.Box className="scrollable-box">
                                      Tax
                                    </Index.Box>
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    className="table-th"
                                  >
                                    <Index.Box className="scrollable-box">
                                      Tax Name
                                    </Index.Box>
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    className="table-th"
                                  >
                                    <Index.Box className="scrollable-box">
                                      Net Amount
                                    </Index.Box>
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    className="table-th"
                                  >
                                    <Index.Box className="scrollable-box">
                                      Rate
                                    </Index.Box>
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    className="table-th"
                                  >
                                    <Index.Box className="scrollable-box">
                                      Amount
                                    </Index.Box>
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    className="table-th"
                                  >
                                    <Index.Box className="scrollable-box">
                                      Balance
                                    </Index.Box>
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    className="table-th"
                                  >
                                    <Index.Box className="scrollable-box">
                                      Calc
                                    </Index.Box>
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    className="table-th"
                                  >
                                    <Index.Box className="scrollable-box">
                                      Action
                                    </Index.Box>
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {taxRow?.map((row, index) => (
                                  <TableRow key={row?.id}>
                                    <TableCell
                                      component="td"
                                      scope="row"
                                      className="table-td"
                                    >
                                      <Index.Box className="scrollable-box">
                                        {index + 1}
                                      </Index.Box>
                                    </TableCell>
                                    <TableCell
                                      component="td"
                                      scope="row"
                                      className="table-td"
                                    >
                                      <Index.Box className="scrollable-box">
                                        {row?.taxCode || ""}
                                      </Index.Box>
                                    </TableCell>
                                    <TableCell
                                      component="td"
                                      scope="row"
                                      className="table-td"
                                    >
                                      <Index.Box className="scrollable-box">
                                        <Index.Box className="dropdown-box auto-drop-box">
                                          <Autocomplete
                                            className="custom-form-control"
                                            value={
                                              taxCategoryOptions?.find(
                                                (ele) => ele?.Id == row?.taxId,
                                              ) || null
                                            }
                                            disabled={
                                              watch("party") ? false : true
                                            }
                                            getOptionDisabled={(option) => {
                                              const salesType =
                                                watch("salesType");

                                              const foundIndex =
                                                taxRow?.findIndex(
                                                  (ele, i) => {
                                                    return (
                                                      ele?.taxId ===
                                                      option.Id &&
                                                      index !== i
                                                    );
                                                  }
                                                );
                                              if (salesType === "Local") {
                                                if (
                                                  option?.tax_type === "I.GST"
                                                ) {
                                                  return true;
                                                }
                                              } else {
                                                if (
                                                  option?.tax_type ===
                                                  "S.GST" ||
                                                  option?.tax_type === "C.GST"
                                                ) {
                                                  return true;
                                                }
                                              }
                                              if (
                                                foundIndex !== -1 ||
                                                (salesType === "Local" &&
                                                  option?.tax_type === "I.GST") ||
                                                (salesType !== "Local" &&
                                                  (option?.tax_type ===
                                                    "S.GST" ||
                                                    option?.tax_type ===
                                                    "C.GST"))
                                              ) {
                                                return true;
                                              }
                                              return false;
                                            }}
                                            options={taxCategoryOptions || []}
                                            autoHighlight
                                            onChange={(e, newValue) => {
                                              handleChangeTaxData(
                                                index,
                                                "taxId",
                                                newValue?.Id,
                                              );
                                            }}
                                            getOptionLabel={(option) =>
                                              `${option?.tax_name}`
                                            }
                                            renderOption={(props, option) => (
                                              <Index.Box
                                                component="li"
                                                sx={{
                                                  "& > img": {
                                                    mr: 2,
                                                    flexShrink: 0,
                                                  },
                                                }}
                                                {...props}
                                              >
                                                {`${option?.tax_name}`}
                                              </Index.Box>
                                            )}
                                            renderInput={(params) => (
                                              <Index.TextField
                                                fullWidth
                                                className="inner-custom-form-control"
                                                error={checkIncludeError(
                                                  `taxId${index}`,
                                                )}
                                                {...params}
                                                size="small"
                                                variant="outlined"
                                              />
                                            )}
                                          />
                                        </Index.Box>
                                      </Index.Box>
                                    </TableCell>
                                    <TableCell
                                      component="td"
                                      scope="row"
                                      className="table-td"
                                    >
                                      <Index.Box className="scrollable-box">
                                        <Index.Box className="input-box">
                                          <Index.Box className="form-group">
                                            <Index.TextField
                                              fullWidth
                                              id="fullWidth"
                                              className="custom-form-control"
                                              type="number"
                                              value={row?.netAmount}
                                              onChange={(e) => {
                                                handleChangeRowNetAmount(
                                                  index,
                                                  e.target.value,
                                                );
                                              }}
                                            />
                                          </Index.Box>
                                        </Index.Box>
                                      </Index.Box>
                                    </TableCell>

                                    <TableCell
                                      component="td"
                                      scope="row"
                                      className="table-td"
                                    >
                                      <Index.Box className="scrollable-box">
                                        {row?.taxType === "DISCOUNT" ? (
                                          <Index.Box className="input-box">
                                            <Index.Box className="form-group">
                                              <Index.TextField
                                                fullWidth
                                                id={`taxRate-${index}`}
                                                className="custom-form-control"
                                                type="number"
                                                step="0.01"
                                                value={row?.taxRate ?? ""}
                                                onChange={(e) =>
                                                  handleChangeTaxRate(
                                                    index,
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </Index.Box>
                                          </Index.Box>
                                        ) : (
                                          <span>{row?.taxRate || ""}</span>
                                        )}
                                      </Index.Box>
                                    </TableCell>

                                    <TableCell
                                      component="td"
                                      scope="row"
                                      className="table-td"
                                    >
                                      <Index.Box className="scrollable-box">
                                        <Index.Box className="input-box">
                                          <Index.Box className="form-group">
                                            <Index.TextField
                                              fullWidth
                                              id="fullWidth"
                                              className="custom-form-control"
                                              value={row?.amount}
                                              disabled={Number(row?.taxRate) > 0}
                                              inputRef={(el) => (inputRefs.current[index] = el)}
                                              onChange={(e) => {
                                                const cursorPos = e.target.selectionStart;
                                                handleChangeChargeData(
                                                  index,
                                                  "amount",
                                                  e.target.value,
                                                );
                                                requestAnimationFrame(() => {
                                                  inputRefs.current[index]?.setSelectionRange(cursorPos, cursorPos);
                                                });
                                              }}
                                            />
                                          </Index.Box>
                                        </Index.Box>
                                      </Index.Box>
                                    </TableCell>
                                    <TableCell
                                      component="td"
                                      scope="row"
                                      className="table-td"
                                    >
                                      <Index.Box className="scrollable-box">
                                        {row?.balance}
                                      </Index.Box>
                                    </TableCell>
                                    <TableCell
                                      component="td"
                                      scope="row"
                                      className="table-td"
                                    >
                                      <Index.Box className="scrollable-box">
                                        {row?.calculated == "ADD"
                                          ? "(+)"
                                          : row?.calculated == "DEDUCT"
                                            ? "(-)"
                                            : "()"}
                                      </Index.Box>
                                    </TableCell>
                                    <TableCell
                                      component="td"
                                      scope="row"
                                      className="table-td action-plus"
                                    >
                                      <Index.Box className="scrollable-box">
                                        <Index.Box className="add-more-content-btn">
                                          <>
                                            {taxRow?.length > 1 ? (
                                              <Index.Box
                                                onClick={() => {
                                                  removeTaxRow(row?.id);
                                                }}
                                                className="table-btns table-minus-btn"
                                                disableRipple
                                              >
                                                <img
                                                  src={Index.Png.Minus}
                                                  className="table-icons"
                                                  alt="Minus"
                                                ></img>
                                              </Index.Box>
                                            ) : (
                                              <></>
                                            )}
                                            {index + 1 == taxRow?.length ? (
                                              <Index.Box
                                                className="table-btns table-plus-btn"
                                                disableRipple
                                                onClick={() => {
                                                  addTaxRow();
                                                }}
                                              >
                                                <img
                                                  src={Index.Png.Plus}
                                                  className="table-icons"
                                                  alt="Plus"
                                                ></img>
                                              </Index.Box>
                                            ) : (
                                              <></>
                                            )}
                                          </>
                                        </Index.Box>
                                      </Index.Box>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                  ) : (
                    <></>
                  )}

                  <Index.Box className="gross-row">
                    <Index.FormHelperText className="gross-lable"></Index.FormHelperText>
                    <Index.FormHelperText className="gross-lable"></Index.FormHelperText>
                    <Index.FormHelperText className="gross-lable"></Index.FormHelperText>
                    <Index.FormHelperText className="gross-lable"></Index.FormHelperText>
                    <Index.FormHelperText className="gross-lable">
                      {/* <b>
                        Tax Amount :{" "}
                       
                        {Number(
                          taxRow?.reduce(
                            (sum, data) =>
                              data?.taxType !== "OTHERS"
                                ? sum + (Number(data?.amount) || 0)
                                : sum,
                            0
                          ) || 0
                        ).toFixed(2)}
                      </b> */}
                      <b>
                        Tax Amount:{" "}
                        {Number(
                          taxRow?.reduce(
                            (sum, data) =>
                              data?.taxType !== "OTHERS" &&
                                data?.taxType !== "DEDUCT" &&
                                data?.taxType !== "DISCOUNT"
                                ? sum + (Number(data?.amount) || 0)
                                : sum,
                            0,
                          ) || 0,
                        ).toFixed(2)}
                      </b>
                      {/* <b>Tax Amount : {watch("totalTaxAmount") || 0}</b> */}
                    </Index.FormHelperText>
                    <Index.FormHelperText className="gross-lable">
                      {/* <b>Total Amount : {
                        taxRow?.reduce((sum, data) => sum + (data?.balance || 0), 0) || 0
                      }</b> */}
                      {/* <b>Total Amount : {watch("totalAmount") || 0}</b> */}
                      <b>
                        Total Amount:{" "}
                        {taxRow?.length > 0
                          ? Number(taxRow[taxRow.length - 1]?.balance || 0).toFixed(2)
                          : Number(watch("netAmount") || 0).toFixed(2)
                        }
                      </b>
                    </Index.FormHelperText>
                  </Index.Box>
                  <Index.Box className="btn-flex-end">
                    <Index.Box className="btn-secondary-main">
                      <Index.Button
                        variant=""
                        className="btn-secondary"
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </Index.Button>
                    </Index.Box>
                    <Index.Box className="btn-primary-main">
                      <Index.Button
                        variant=""
                        className="btn-primary"
                        type="submit"
                        disabled={editId && editData?.jvTds === 1}
                      >
                        Save
                      </Index.Button>
                    </Index.Box>
                  </Index.Box>
                </form>
              </Index.Box>
            </Index.Box>
          </Index.Box>
        </Index.Box>
      </div>
    );
  }
}


